import { render, staticRenderFns } from "./detail_two.vue?vue&type=template&id=77912cec&scoped=true&"
import script from "./detail_two.vue?vue&type=script&lang=js&"
export * from "./detail_two.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77912cec",
  null
  
)

export default component.exports